/**
 * Coerce Algolia/Dynamo boolean fields that may arrive as bool or string.
 */
export function coerceTypesenseBoolField(value: unknown): boolean | undefined {
  if (value === true || value === 'true') return true;
  if (value === false || value === 'false') return false;
  return undefined;
}
